import React from "react";
import { Badge } from "components/src/components/Badge/Badge";
import { LegType, LegOptionsType } from "components/src/components/Legs/types";
import { badgeIcon } from "./badgeIcon";
import { QuickPickBadgeType, SingleEventLeg, StartTime } from "../types";
import { Icon } from "components/src/components/Icon/Icon";
import { EventDetailsType } from "../../EventDetails/types";

export function computeLegs({
  badge,
  title,
  showBadge,
  legs,
  startTime,
  eventDetails, 
  showTime,
  isLive,
  isSingleLeg,
  disableAutomatedTitle
}: {
  badge: QuickPickBadgeType;
  title?: string;
  showBadge?: boolean;
  startTime?: StartTime;
  showTime?: boolean;
  eventDetails?: EventDetailsType;
  legs: (SingleEventLeg)[];
  isLive?: boolean;
  isSingleLeg?: boolean;
  disableAutomatedTitle?: boolean;
}) {
// <Badge type="strong" size="xs" bgColor="bg-primary" shape="square" iconColor="fg-inverse" icon={badgeIcon[badge]} />
  const titleLeg: LegType & { options: LegOptionsType } = {
    icon: <div className={`${ isLive ? "cui-bg-highlight-accent" : "cui-bg-bg-primary" } cui-w-auto cui-h-4 cui-px-2xs cui-rounded-2px`}><Icon name={badgeIcon[badge]} color="fg-inverse" /></div>,
    text: title,
    boldText: true,
    isTitle: true,
    options: {
      hideBottomPole: isLive ? true : false
    },
  };

  const eventDetailsLeg: LegType & { options: LegOptionsType, eventDetails?: EventDetailsType, isEventDetails: boolean } | {} = typeof eventDetails === "object" ? {
    eventDetails,
    isEventDetails: true,
    options: {
      hideBullet: true
    }
  } : {};

  if (!showBadge || isSingleLeg) {
    titleLeg.icon = null;
    titleLeg.options.hideBullet = true;
  }

  return {
    titleLeg,
    // eventDetailsLeg,
    legs: [eventDetailsLeg, ...legs.map((leg) => ({
      text: leg.selectionDisplayName,
      id: leg?.marketId,
      isSingleLeg,
      hasEventDetails: typeof eventDetails !== "undefined" && typeof eventDetails === "object",
      ...leg,
    })),
    ]
  };
}
